module.exports = __webpack_public_path__ + "img/90fa3a7.svg";